import React from 'react';
import { useSelector } from 'react-redux';
import { formatPercentage } from '../../../../../common';
import CardComponent from '../../../../../common/components/CardComponent';
import { RootState } from '../../../../../reducers';
import { theme } from '../../../../../themes';

interface Props {
  isLoading: boolean;
  hasErrors: boolean;
}

const GainLossPercentageCard = (props: Props): JSX.Element => {
  const { isLoading, hasErrors } = props;
  const value = useSelector((state: RootState) => state.clients.client.gainsAndLosses?.results?.gainLossPercentage);

  return (
    <CardComponent progress={{ isLoading, hasErrors }} background={theme.palette.gradient2?.main} value={formatPercentage(value)} subText={'GAIN/LOSS (%)'} />
  );
};

export default GainLossPercentageCard;
